module.exports={
	"Form": "ReportNamedInstanceViewManifest",
	"Scope": "ReportNamedInstance-View",
	"Descriptors":
	{
		"ReportNamedInstanceDetails.IDReportNamedInstance":
		{
			"Name": "ID",
			"Hash": "RNIView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "RNIIdentity",
				"Group": "RNIIdentity"
			}
		},
		"ReportNamedInstanceDetails.GUIDReportNamedInstance":
		{
			"Name": "GUID",
			"Hash": "RNIView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "RNIIdentity",
				"Group": "RNIIdentity"
			}
		},
		"ReportNamedInstanceDetails.Name":
		{
			"Name": "Name",
			"Hash": "RNIView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "RNIIdentity",
				"Group": "RNIIdentity"
			}
		},
		"ReportNamedInstanceDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "RNIView-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "RNIConfig",
				"Group": "RNIConfig"
			}
		},
		"ReportNamedInstanceDetails.DefaultReport":
		{
			"Name": "Default Report",
			"Hash": "RNIView-DefaultReport",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 2,
				"Section": "RNIConfig",
				"Group": "RNIConfig"
			}
		},
		"ReportNamedInstanceDetails.OptionsJSON":
		{
			"Name": "Options (JSON)",
			"Hash": "RNIView-Options",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "RNIOptions",
				"Group": "RNIOptions"
			}
		},
		"ReportNamedInstanceDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "RNIView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "RNIAudit",
				"Group": "RNIAudit"
			}
		},
		"ReportNamedInstanceDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "RNIView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "RNIAudit",
				"Group": "RNIAudit"
			}
		},
		"ReportNamedInstanceDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "RNIView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "RNIAudit",
				"Group": "RNIAudit"
			}
		},
		"ReportNamedInstanceDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "RNIView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "RNIAudit",
				"Group": "RNIAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "RNIIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "RNIIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "RNIConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "RNIConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Options",
			"Hash": "RNIOptions",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Options",
					"Hash": "RNIOptions",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "RNIAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "RNIAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
